import { Component, OnInit, ViewChild } from '@angular/core';
import { AppInformationService, AuthService, GenesisUnitOfWork } from 'app/core/core.module';
import { ContactLog, ContactMethod, ContactType } from 'app/core/model/entity-model';
import { SharedModule } from 'app/shared/shared.module';
import { DxDataGridComponent } from 'devextreme-angular';
import { confirm } from 'devextreme/ui/dialog';
import { BsModalService } from 'ngx-bootstrap/modal';
import { ContactLogDialogComponent } from '../contact-log-dialog/contact-log-dialog.component';

@Component({
    selector: 'app-contact-log-overview',
    templateUrl: './contact-log-overview.component.html',
    styleUrls: ['./contact-log-overview.component.scss'],
    standalone: false
})
export class ContactLogOverviewComponent implements OnInit {
    contactLogs: any;

    @ViewChild('dataGrid') dataGrid: DxDataGridComponent;
    onExporting = SharedModule.onExporting;

    constructor(
        private appInfo: AppInformationService,
        public auth: AuthService,
        private uow: GenesisUnitOfWork,
        private modalService: BsModalService,
    ) {}

    async ngOnInit() {
        const contactMethods = (await this.uow.contactMethods.whereActive()) as ContactMethod[];
        const contactTypes = (await this.uow.contactTypes.whereActive()) as ContactType[];
        await this.getData();
    }

    async getData() {
        this.contactLogs = await this.uow.getContactLogs('dealer, vendor, orderLineDetail');
    }

    async add(contactLog?: ContactLog) {
        const modalRef = this.modalService.show(ContactLogDialogComponent, {
            class: 'modal-md',
            ignoreBackdropClick: true,
            keyboard: false,
            initialState: {
                contactLog: contactLog ? contactLog : null,
            },
        });

        modalRef.content.result.subscribe(async (result) => {
            if (result.success) {
                this.appInfo.pleaseWaitShow();
                await this.getData();
                this.appInfo.pleaseWaitHide();
                this.dataGrid.instance.clearSelection();
            }
            modalRef.hide();
        });
    }

    async delete() {
        const selectedRow = this.dataGrid.instance.getSelectedRowsData()[0];
        if (!selectedRow) return;

        const result = await confirm(`Are you sure you want to DELETE this record?`, `${this.appInfo.settings.company}`);
        if (!!result) {
            this.appInfo.pleaseWaitShow();
            selectedRow.deleted = new Date();
            selectedRow.deletedBy = this.auth.currentUser.userName;
            await this.uow.commit();
            await this.getData();
            this.appInfo.pleaseWaitHide();
        }
    }

    selectionChange(e) {}

    onToolbarPreparing(e) {
        e.toolbarOptions.items.unshift(
            {
                location: 'before',
                template: 'toolbarButtons',
            },
            {
                template: 'toolbarText',
                location: 'after',
            },
            {
                widget: 'dxButton',
                options: {
                    icon: 'revert',
                    elementAttr: { title: 'Reset Filters' },
                    onClick: () => {
                        e.component.clearFilter();
                    },
                },
                location: 'after',
            },
            {
                widget: 'dxButton',
                options: {
                    icon: 'refresh',
                    elementAttr: { title: 'Reset Grid Layout' },
                    onClick: () => {
                        e.component.state({});
                    },
                },
                location: 'after',
            }
        );
    }

    async open(id: number) {
        // this.router.navigate(['/vendors/overview/' + (!!id ? id : 'new')]);
    }

    async rowDoubleClick(e) {
        // if (!e.data || !e.data.id) return;
        // this.open(e.data.id);
    }
}
